var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbsDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "currentcolor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 5.5C7.125 5.38493 7.10112 5.27914 7.05337 5.18263C7.00561 5.08612 6.93398 4.99332 6.83847 4.90423L2.24797 0.711581C2.09276 0.570527 1.90373 0.5 1.68087 0.5C1.53761 0.5 1.40429 0.533408 1.28092 0.600223C1.15755 0.667038 1.05806 0.757981 0.98245 0.873051C0.910817 0.98441 0.875 1.10876 0.875 1.2461C0.875 1.45397 0.958572 1.63586 1.12572 1.79176L5.21478 5.5L1.12572 9.20824C0.958572 9.36785 0.875 9.54974 0.875 9.7539C0.875 9.89495 0.910817 10.0212 0.98245 10.1325C1.05806 10.2439 1.15755 10.333 1.28092 10.3998C1.40429 10.4666 1.53761 10.5 1.68087 10.5C1.90373 10.5 2.09276 10.4295 2.24797 10.2884L6.83847 6.09577C6.93796 6.00668 7.00959 5.91388 7.05337 5.81737C7.10112 5.71715 7.125 5.61136 7.125 5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsDivider);
export default __webpack_public_path__ + "static/media/breadcrumbs_divider.0cbeedf5f527642ee8c06d4fb64a44d8.svg";
export { ForwardRef as ReactComponent };